interface PlatformBadgeProps {
  platform: 'linkedin' | 'instagram' | 'facebook' | 'tiktok' | 'youtube' | 'twitter';
  className?: string;
}

export default function PlatformBadge({ platform, className = '' }: PlatformBadgeProps) {
  const platformConfig = {
    linkedin: {
      color: 'bg-[#0077b5] text-white',
      label: 'LINKEDIN',
    },
    instagram: {
      color: 'bg-[#E1306C] text-white',
      label: 'INSTAGRAM',
    },
    facebook: {
      color: 'bg-[#1877f2] text-white',
      label: 'FACEBOOK',
    },
    tiktok: {
      color: 'bg-black text-white',
      label: 'TIKTOK',
    },
    youtube: {
      color: 'bg-[#FF0000] text-white',
      label: 'YOUTUBE',
    },
    twitter: {
      color: 'bg-[#1da1f2] text-white',
      label: 'TWITTER',
    },
  };

  const config = platformConfig[platform];

  return (
    <span
      className={`
        inline-block px-2 py-1 rounded text-xs font-bold border border-black
        ${config.color}
        ${className}
      `}
    >
      {config.label}
    </span>
  );
}
